/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetHotelRoomInfoApiRequest } from '../../models/get-hotel-room-info-api-request';
import { HotelRoomsResponseResultApiResult } from '../../models/hotel-rooms-response-result-api-result';

export interface ApiHotelGetHotelRoomInfoPost$Params {
      body: GetHotelRoomInfoApiRequest
}

export function apiHotelGetHotelRoomInfoPost(http: HttpClient, rootUrl: string, params: ApiHotelGetHotelRoomInfoPost$Params, context?: HttpContext): Observable<StrictHttpResponse<HotelRoomsResponseResultApiResult>> {
  const rb = new RequestBuilder(rootUrl, apiHotelGetHotelRoomInfoPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HotelRoomsResponseResultApiResult>;
    })
  );
}

apiHotelGetHotelRoomInfoPost.PATH = '/api/hotel/GetHotelRoomInfo';
